import { render } from "./_role_setting_preview.vue?vue&type=template&id=ace388a8&lang=pug"
import script from "./_role_setting_preview.vue?vue&type=script&lang=js"
export * from "./_role_setting_preview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__